"use client";

import { SearchX, ArrowRight } from "@/components/icons";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useListingBrowseContext } from "./context/listing-browse-context";

export function ListingEmptyState() {
  const { hasActiveFilters, clearAllFilters } = useListingBrowseContext();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="h-14 w-14 rounded-2xl bg-muted flex items-center justify-center mb-4">
        <SearchX className="h-7 w-7 text-muted-foreground" />
      </div>

      <h3 className="text-lg font-semibold text-foreground mb-6">
        No listings found
      </h3>

      <div className="flex flex-col sm:flex-row items-center gap-3">
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            type="button"
            onClick={clearAllFilters}
          >
            Clear all filters
          </Button>
        )}

        <Button variant="primary" asChild size="sm">
          <Link href="/request-quote">
            Request a Custom Quote
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
